import {WebsiteActions} from "./actions";
import {notifyError, notifySuccess} from "@nutastic/nutastic-react-app";
import togglePageLock from '../utils/togglePageLock.js';

const reducer = (state, action) => {
    switch (action.type) {
        case WebsiteActions.LOADING_PAGE_START: {
            return {
                ...state,
                isProcessing: true
            };
        }

        case WebsiteActions.LOADING_PAGE_FAIL:
        case WebsiteActions.LOADING_PAGE_DONE: {
            return {
                ...state,
                isProcessing: false
            };
        }

        case WebsiteActions.REUP_STARTED: {
            return {
                ...state,
                isReloadingAppData: true
            }
        }

        case WebsiteActions.REUP_DONE: {
            const {pages: { homePage }} = action;
            return {
                ...state,
                isReloadingAppData: false,
                pages: {
                    ...state.pages,
                    homePage
                }
            };
        }

        case WebsiteActions.REUP_FAIL: {
            return {
                ...state,
                isReloadingAppData: false
            }
        }

        case WebsiteActions.REGISTER_STARTED:
        case WebsiteActions.LOGIN_STARTED: {
            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: true,
                    isAuthenticated: false
                }
            };
        }

        case WebsiteActions.REGISTER_COMPLETE:
        case WebsiteActions.LOGIN_COMPLETE: {
            const { accountInfo, isSubscribed, renewalDate, recentVideos, recentMusic, hasCanceled, subType } = action;

            return {
                ...state,
                recentVideos,
                recentMusic,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: false,
                    isAuthenticated: true,
                    authError: '',
                    accountInfo,
                    isSubscribed,
                    renewalDate,
                    hasCanceled,
                    subType
                }
            };
        }

        case WebsiteActions.APP_MESSAGE_CHANGE: {
            const { title, text } = action;
            return {
                ...state,
                appMessage: {
                    title,
                    text
                }
            };
        }

        case WebsiteActions.REGISTER_FAIL:
        case WebsiteActions.LOGIN_FAILED: {
            const { authError } = action;

            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: false,
                    isAuthenticated: false,
                    authError,
                    accountInfo: null
                }
            };
        }

        case WebsiteActions.LOGOUT: {
            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    accountInfo: null,
                    isAuthenticated: false,
                    isProcessingLogin: false,
                    authError: ''
                }
            };
        }

        case WebsiteActions.ACCOUNT_MODAL_SHOW: {
            togglePageLock(true);
            return {
                ...state,
                accountState: {
                    isActive: true
                }
            }
        }

        case WebsiteActions.ACCOUNT_MODAL_HIDE: {
            togglePageLock(false);
            return {
                ...state,
                accountState: {
                    isActive: false
                }
            }
        }

        case WebsiteActions.RECENT_VIDEOS_UPDATED: {
            const { data } = action;
            return {
                ...state,
                recentVideos: data
            }
        }

        case WebsiteActions.RECENT_MUSIC_UPDATED: {
            const { data } = action;
            return {
                ...state,
                recentMusic: data
            }
        }

        default:
            return state;
    }
};

export default reducer;
